<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn data-v-step="3" fab v-on="on" small @click="reset()" label="Nullstill rotasjon"
                aria-label="Nullstill rotasjon">
        <i :style="rotationStyle" class="esri-icon-compass"></i>
      </v-btn>
    </template>
    <span>Kompass / Tilbakestill rotasjon</span>
  </v-tooltip>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
export default {
  name: "MapCompassNavigation",
  data: function() {
    return {
      compassViewModel: null
    };
  },
  computed: {
    ...mapState(["is3d", "currentOrientation"]),
    currentOrientation: {
      set(currentOrientation) {
        this.setCurrentOrientation(currentOrientation);
      },
      get() {
        return this.$store.state.currentOrientation;
      }
    },
    rotationStyle() {
      return { transform: "rotateZ(" + this.currentOrientation + "deg)" };
    }
  },
  watch: {
    is3d() {
      this.loadCompass();
    }
  },
  methods: {
    ...mapActions(["setCurrentOrientation"]),
    reset: function() {
      this.compassViewModel.reset();
    },

    loadCompass: function() {
      loadModules(["esri/widgets/Compass/CompassViewModel"]).then(
        function([CompassViewModel]) {
          this.compassViewModel = new CompassViewModel({
            view: this.is3d ? this.$theSceneViewObject : this.$theMapViewObject
          });
          this.compassViewModel.watch(
            "orientation",
            function(currentOrientation) {
              this.currentOrientation = currentOrientation.z;
            }.bind(this)
          );
        }.bind(this)
      );
    }
  },
  mounted() {
    this.loadCompass();
  }
};
</script>

<style></style>
